// @flow
import StandardMasonry from 'app/common/react/components/Masonry9/StandardMasonry';
import { Masonry } from 'gestalt';

const MEASUREMENT_CACHE: {
  [key: string]: {
    screenWidth: number,
    cache: Object,
  },
} = {};

export const getMeasurementCache = (cacheKey: ?string, useMasonry9: ?boolean) => {
  if (cacheKey == null || __SERVER__) {
    return undefined;
  }

  // Masonry blindly accepts measurement stores even if the screen has changed
  // size, so we need to be sure to clear it here when requesting the same
  // measurements for a different screen.
  if (
    !MEASUREMENT_CACHE[cacheKey] ||
    MEASUREMENT_CACHE[cacheKey].screenWidth !== window.innerWidth
  ) {
    MEASUREMENT_CACHE[cacheKey] = {
      screenWidth: window.innerWidth,
      cache: useMasonry9
        ? StandardMasonry.createMeasurementStore()
        : Masonry.createMeasurementStore(),
    };
  }

  return MEASUREMENT_CACHE[cacheKey].cache;
};

export const getMinColumnHeight = ({
  cacheKey,
  useMasonry9,
}: {|
  cacheKey: ?string,
  useMasonry9: ?boolean,
|}): number => {
  const measurementCache = getMeasurementCache(cacheKey, useMasonry9);
  if (!measurementCache) {
    return 0;
  }
  if (useMasonry9) {
    if (measurementCache.layout && measurementCache.layout.contentFilledSize) {
      const contentFilledSize = measurementCache.layout.contentFilledSize;
      return contentFilledSize.height;
    }
  } else if (measurementCache.columnHeights) {
    // Check that the shortest column is longer than the grid height
    return Math.min(...measurementCache.columnHeights);
  }
  return 0;
};
